export const forms = {
    updatePartnersForm: 'updatePartnersForm',
};
